// extracted by mini-css-extract-plugin
export default {"image":"x2-z","loaded":"y2-z"};